import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Track page views and custom events with Google Analytics 4.
 * gtag is loaded via /public/index.html; we manually send page_view on every
 * route change because React Router doesn't trigger full page loads.
 */
export const useGAPageView = () => {
  const location = useLocation();
  useEffect(() => {
    const gaId = typeof window !== "undefined" ? window.WAZI_GA_ID : null;
    if (gaId && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location]);
};

export const trackEvent = (eventName, params = {}) => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
  } catch (e) {
    // never break the UI on analytics failure
  }
};
